import { supabase } from "../../supabaseClient"

export const saveProductionPhase = async (id = undefined, item) => {
    if (id) {
        return await supabase
            .from('ProcSteps')
            .update({ ...item })
            .match({ id })
    } else {
        return await supabase
            .from('ProcSteps')
            .insert([{ ...item }])
    }
}